import { styled } from "@mui/material";
export const BlodContent = styled("div")(() => ({
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    flex: 1,
    justifyContent: "space-around",
}));
export const NewsContainer = styled("div")(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(3),
    },
}));
export const NewsImage = styled("img")(({ theme }) => ({
    width: "100%",
    height: "auto",
    borderRadius: theme.spacing(1),
    objectFit: "cover",
    display: "block",
    [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
        maxHeight: "250px",
        borderRadius: theme.spacing(1),
    },
    [theme.breakpoints.up("md")]: {
        maxWidth: "600px",
        maxHeight: "400px",
        borderRadius: theme.spacing(1.25),
    },
}));
export const NewsContent = styled("div")(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    overflowWrap: "break-word",
    wordWrap: "break-word",
    "& img": {
        maxWidth: "100%",
        height: "auto",
        display: "block",
        margin: "0 auto",
    },
    "& p": {
        marginBottom: theme.spacing(2),
        wordWrap: "break-word",
        overflowWrap: "break-word",
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(1rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.6,
            marginBottom: theme.spacing(1.5),
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1.1rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.7,
            marginBottom: theme.spacing(2),
        },
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
        fontWeight: 600,
        wordWrap: "break-word",
        overflowWrap: "break-word",
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(1.25rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.3,
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1.5rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.4,
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(1.5),
        },
    },
    "& ul, & ol": {
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            paddingLeft: theme.spacing(2),
            marginBottom: theme.spacing(1.5),
        },
        [theme.breakpoints.up("md")]: {
            paddingLeft: theme.spacing(2.5),
            marginBottom: theme.spacing(2),
        },
    },
    "& li": {
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(1rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.6,
            marginBottom: theme.spacing(0.75),
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1.1rem + var(--accessibility-font-delta, 0px))",
            lineHeight: 1.7,
            marginBottom: theme.spacing(1),
        },
    },
    "& table": {
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
        display: "block",
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(0.9rem + var(--accessibility-font-delta, 0px))",
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1rem + var(--accessibility-font-delta, 0px))",
        },
    },
    "& th, & td": {
        padding: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        wordWrap: "break-word",
        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(0.75),
        },
        [theme.breakpoints.up("md")]: {
            padding: theme.spacing(1),
        },
    },
    "& a": {
        color: theme.palette.primary.main,
        textDecoration: "none",
        wordBreak: "break-word",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    "& code": {
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        fontFamily: "monospace",
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(0.9rem + var(--accessibility-font-delta, 0px))",
            padding: theme.spacing(0.25, 0.5),
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1rem + var(--accessibility-font-delta, 0px))",
            padding: theme.spacing(0.5, 0.75),
        },
    },
    "& pre": {
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        overflowX: "auto",
        margin: theme.spacing(2, 0),
        [theme.breakpoints.down("md")]: {
            fontSize: "calc(0.9rem + var(--accessibility-font-delta, 0px))",
            padding: theme.spacing(1.5),
            margin: theme.spacing(1.5, 0),
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "calc(1rem + var(--accessibility-font-delta, 0px))",
            padding: theme.spacing(2),
            margin: theme.spacing(2, 0),
        },
    },
}));
